import React from 'react';
import { convertPropToCssClassName } from '@elliemae/ds-classnames';
import { DSIconColors, DSIconSizes } from '@elliemae/ds-icon';
import { MoreOptionsVert, GripperVertical } from '@elliemae/ds-icons';

const DragContainerController = ({
  color = DSIconColors.NEUTRAL,
  icon: Icon = GripperVertical,
  size = DSIconSizes.S,
  multipleSize = false,
  onClick,
}) => {
  const { cssClassName } = convertPropToCssClassName('query-builder-drag-group');
  return (
    <div className={`${cssClassName}`}>
      <Icon color={color} size={size} />
      <div className="separator" />
      <MoreOptionsVert color={color} onClick={onClick} size={size} />
      {multipleSize && <Icon className="additional-drag" color={color} onClick={onClick} size={size} />}
    </div>
  );
};
export default DragContainerController;
